import React from 'react'
import { Outlet } from 'react-router-dom'
import SpliTemplateScreenCabinet from 'layouts/SplitTemplates/SpliTemplateScreenCabinet'
import NavbarComponentCabinet from 'layouts/navbar/NavbarComponentCabinet'
import SidebarComponentCabinet from 'layouts/sidebar/SidebarComponentCabinet'



const DashboardAppShellCabinet = () => {
  return (
    <>
    <SpliTemplateScreenCabinet>
      <NavbarComponentCabinet />
        <SidebarComponentCabinet
          activeLinkColor={"#FFFFFF"}
          activeLinkBgColor={"#009688"}
          colorOnHover={"white"}
          linkColor="#111827"
          color="#111827"
        />
      <Outlet 
      
      />
    </SpliTemplateScreenCabinet>
    </>
  )
}

export default DashboardAppShellCabinet